"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var Storage = /*#__PURE__*/function () {
  function Storage(opt) {
    _classCallCheck(this, Storage);

    this.protection = null;
    this.requirements = null;
    this.remarks = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(Storage, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      Object.keys(this).forEach(function (prop) {
        _this[prop] = opt[prop] || null;
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Storage.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'storage.schema.json',
        type: 'object',
        properties: {
          protection: {
            type: ['string', 'null']
          },
          requirements: {
            type: ['string', 'null']
          },
          remarks: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Storage;
}();

module.exports = Storage;